import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "DeductItem" }

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { modalConfig } from './config/modal.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { usePageModal } from '@/hooks/usePageModal'
import { useStore } from '@/store'
import { ref } from 'vue'
import PageSearch from '@/components/PageSearch.vue'
import PageContent from '@/components/PageContent.vue'
import PageModal from '@/components/PageModal.vue'
import { ILoadingInstance } from 'element-plus/lib/el-loading/src/loading.type'
import { createPageData } from '@/service/main/system'
import { initEmptyParam } from '@/hooks/useInitParam'
import { ElMessage, ElMessageBox,ElLoading, } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  __name: 'NoticeManage',
  setup(__props) {

initEmptyParam()
const store = useStore()
const modalTitle = ref('新增')
const newCb = () => {
  modalTitle.value = '新增'
  pageModalRef.value.isBatch = true
}

const editCb = () => {
  modalTitle.value = '编辑'
}

const [pageModalRef, defaultInfo, handleNewData, handleEditData] = usePageModal(
  newCb,
  editCb
)

const [pageContentRef, handleResetClick, handleSearchClick] = usePageSearch()

const handleAddData = async (formData: any) => {
   try {
    await createPageData('/main/notices', {...formData})
        ElMessage({ type: 'success',message: '提交成功！'})
        let loadingInstance: ILoadingInstance = {} as ILoadingInstance
        if (document.querySelector('.el-table__body-wrapper')) {
          loadingInstance = ElLoading.service({
            target: '.el-table__body-wrapper',
            text: '加载中....',
            spinner: 'el-icon-loading',
            background: 'rgba(255, 255, 255, 0.8)',
            fullscreen: false
          })
        }
        store.dispatch('system/getPageListAction', {
            pageName: 'notices',
            queryInfo: store.state.system.queryInfo,
            pageUrl: '/main/notices/page'
          })
          .finally(() => {
            if (
              loadingInstance &&
              typeof loadingInstance.close == 'function'
            ) {
              loadingInstance.close()
            }
          })
             pageModalRef.value.dialogVisible = false
          } finally {
           pageModalRef.value.confirmLoading = false
          }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "notices",
      pageUrl: "/main/notices/page",
      deleteTip: "确认删除此项吗？",
      onNewBtnClick: _unref(handleNewData),
      onEditBtnClick: _unref(handleEditData)
    }, null, 8, ["contentTableConfig", "onNewBtnClick", "onEditBtnClick"]),
    _createVNode(PageModal, {
      ref_key: "pageModalRef",
      ref: pageModalRef,
      defaultInfo: _unref(defaultInfo),
      modalConfig: _unref(modalConfig),
      title: modalTitle.value,
      pageName: "notices",
      onUpdateBatchData: handleAddData,
      validOtherInfo: () => true
    }, null, 8, ["defaultInfo", "modalConfig", "title"])
  ]))
}
}

})